import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { ISalesOrder } from '../../../order';

interface ISalesOrderDropdownActionCellRendererParams extends ICellRendererParams {
  propertyName :string;
  onClickEvent :(data :ISalesOrder) => void;
}

@Component({
  selector: 'lum-sales-order-clickable-cell-renderer',
  templateUrl: './sales-order-clickable-cell-renderer.component.html',
  styleUrls: ['./sales-order-clickable-cell-renderer.component.scss'],
})
export class SalesOrderClickableCellRendererComponent
  implements ICellRendererAngularComp
{
  params :ISalesOrderDropdownActionCellRendererParams;
  value :string = '';

  constructor() {}

  agInit(params :ISalesOrderDropdownActionCellRendererParams) :void {
    this.params = params;
    if (this.params.propertyName) {
      this.value = this.params?.data?.[this.params.propertyName];
    }
  }

  refresh(params :ISalesOrderDropdownActionCellRendererParams) :boolean {
    return false;
  }

  onClickEvent() :void {
    this.params.onClickEvent(this.params.data);
  }
}
